export const enumKeysToArray = <T>(e: any): T[] =>
  (Object.keys(e) as T[]).filter((value) => !Number.isNaN(Number(value))).map((key) => e[key])

export const enumValuesToArray = <T>(e: Record<string, T>): T[] =>
  Object.keys(e)
    .filter((value) => value)
    .map((key) => e[key])
